import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryUkrposhtaForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-ukrposhta',
  templateUrl: './ukrposhta.component.html',
  styleUrls: ['./ukrposhta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UkrposhtaComponent {
  delivery = input<DeliveryUkrposhtaForm>();
}
